import { render, staticRenderFns } from "./DowngradeRestrictedModal.vue?vue&type=template&id=2f6af101"
import script from "./DowngradeRestrictedModal.vue?vue&type=script&lang=ts"
export * from "./DowngradeRestrictedModal.vue?vue&type=script&lang=ts"
import style0 from "./DowngradeRestrictedModal.vue?vue&type=style&index=0&id=2f6af101&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports